import React from "react";
import { observer, inject } from "mobx-react";
import { extendObservable } from "mobx";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import { FormControl } from "react-bootstrap";

@injectIntl
@inject("rootStore")
@observer
export default class NoteSearch extends React.Component {
  constructor(props) {
    super(props);

    extendObservable(this, {
      searchTerm: ""
    });
  }

  render() {
    const {
      intl,
      onChange,
      onRef,
      rootStore,
      placeholder,
      ...props
    } = this.props;

    const placeholderText = placeholder || "search_task";

    return (
      <FormControl
        type="text"
        value={this.searchTerm}
        placeholder={intl.formatMessage({ id: placeholderText })}
        onChange={this.handleOnChange}
        {...props}
      />
    );
  }

  handleOnChange = e => {
    const { rootStore, onChange } = this.props;

    this.searchTerm = e.target.value;

    if (this.searchTerm.trim()) {
      onChange(rootStore.searchNotes.search(this.searchTerm));
    } else {
      onChange([]);
    }
  };

  clear = () => {
    this.searchTerm = "";
  };

  componentDidMount() {
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }
}

NoteSearch.propTypes = {
  onChange: PropTypes.func.isRequired,
  onRef: PropTypes.func.isRequired
};
